import { render } from "./ReportFooter.vue?vue&type=template&id=41595322&ts=true"
import script from "./ReportFooter.vue?vue&type=script&lang=ts"
export * from "./ReportFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__